// Cake (MB.3-remainder). PURE (ENG-1). A placed cake has a `bites` property 0..6;
// right-clicking it with an empty hand while hungry eats one slice (+2 hunger),
// and eating the last slice removes the block. Seven bites total. The host reads
// the block's bites, calls biteCake, then writes the next state or clears it.

/** A cake yields seven slices (bites property runs 0..6). */
export const CAKE_MAX_BITES = 7;
/** Hunger / saturation restored per slice (Java: 2 hunger, 0.4 saturation). */
export const CAKE_HUNGER_PER_BITE = 2;
export const CAKE_SATURATION_PER_BITE = 0.4;

export interface BiteResult {
  /** Whether a bite was actually taken (false if already full). */
  ate: boolean;
  /** The cake's new bites value (only meaningful when `ate`). */
  nextBites: number;
  /** True when this bite finished the cake (the host removes the block). */
  removed: boolean;
  /** Hunger points restored (0 when not eaten). */
  hunger: number;
}

/**
 * Take one bite of a cake currently at `bites` (0..6). You can only eat when
 * hungry (`hunger < maxHunger`); eating the final slice removes the block.
 */
export function biteCake(bites: number, hunger: number, maxHunger: number): BiteResult {
  if (hunger >= maxHunger) return { ate: false, nextBites: bites, removed: false, hunger: 0 };
  const next = bites + 1;
  return { ate: true, nextBites: next, removed: next >= CAKE_MAX_BITES, hunger: CAKE_HUNGER_PER_BITE };
}
